import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | million:exponent
 * Example:
 *   {{ 2 |  million:10}}
 *   formats to: 1024
 */
@Pipe({ name: 'millionize' })
export class MillionPipe implements PipeTransform {
  transform(value: any): any {
    // Nine Zeroes for Billions
    return Math.abs(Number(value)) >= 1.0e9
      ? Math.abs(Number(value)) / 1.0e9 + ' Milliarden'
      : // Six Zeroes for Millions
      Math.abs(Number(value)) >= 1.0e6
      ? Math.abs(Number(value)) / 1.0e6 + ' Mio. €'
      : // Three Zeroes for Thousands
      Math.abs(Number(value)) >= 1.0e3
      ? Math.abs(Number(value)) + ',00 €'
      : Math.abs(Number(value)) + ',00 €';
  }
}
